import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'input, textarea, mat-form-field',
})
export class DisableAutofillDirective implements AfterViewInit {
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.setAttributes();
  }

  private setAttributes() {
    const input = this.el.nativeElement as HTMLInputElement;
    this.renderer.setAttribute(input, 'autocomplete', 'new-password');
    this.renderer.setAttribute(input, 'autocorrect', 'off');
    this.renderer.setAttribute(input, 'spellcheck', 'false');
  }
}

